<template>
    <div class="animated fadeIn">
        <LoadingWidget v-if="initStatus != 1" :status="initStatus" @init="init" />
        <b-card v-else>
            <template v-slot:header>
                <h5>Input Tipe Barang</h5>
            </template>
            <b-form @submit.prevent="openModalConfirm">
                <div class="form-content-wrapper">
                    <h6 class="form-title">DATA UMUM</h6>
                    <b-form-group label="Jenis Barang">
                        <multiselect name="jenisBarang"
                            :value="jenisBarang.find(item => item.id == input.jenisBarang) || null"
                            :options="jenisBarang" :internal-search="true" :allow-empty="false"
                            deselect-label="" select-label="" label="name" track-by="id"
                            placeholder="Pilih Jenis Barang"
                            @input="input.jenisBarang = $event ? $event.id : null" />
                    </b-form-group>
                    <b-form-group label="Merk Barang">
                        <multiselect name="merkBarang"
                            :value="merkBarang.find(item => item.id == input.merkBarang) || null"
                            :options="merkBarang" :internal-search="true" :allow-empty="false"
                            :disabled="!input.jenisBarang" deselect-label="" select-label=""
                            label="name" track-by="id" placeholder="Pilih Merk Barang"
                            @input="input.merkBarang = $event ? $event.id : null" />
                    </b-form-group>
                    <b-form-group label="Nama Tipe Barang">
                        <b-form-input v-model="input.tipeBarang" name="tipeBarang" required></b-form-input>
                        <p class="mb-0 smallText text-muted" v-if="panduanNamaTipe">Panduan Nama Tipe: <bold>{{panduanNamaTipe.name}}</bold></p>
                    </b-form-group>
            
                    <b-form-group v-if="input.jenisBarang != null && input.jenisBarang == 251" label="Berat Emas">
                        <b-input-group append="Gr">
                            <b-form-input v-model="input.berat" name="diatasJasa1" step="0.01" max="100" type="number" @blur="roundPersen('diatas', 'jasa1')"></b-form-input>
                        </b-input-group>
                    </b-form-group>
                        <b-form-group label="Kelompok Barang">
                        <multiselect
                            v-model="input.kelompok" 
                            :options="optKelompok" 
                            :internal-search="true"
                            :allow-empty="false" 
                            deselect-label=""
                            select-label=""
                            label="name"
                            track-by="id"
                        />
                    </b-form-group>

                    <b-form-group v-if="input.jenisBarang != null && input.jenisBarang != 13 && input.jenisBarang != 14">
                        <label>Harga RESMI</label>
                        <b-input-group class="mb-3" prepend="Rp.">
                            <b-form-input v-model="input.hargaResmi" name="hargaResmi" required></b-form-input>
                        </b-input-group>
                        <label>Harga LN</label>
                        <b-input-group class="mb-3" prepend="Rp.">
                            <b-form-input v-model="input.hargaLN" name="hargaLN" required></b-form-input>
                        </b-input-group>
                        <label>Harga RR</label>
                        <b-input-group class="mb-3" prepend="Rp.">
                            <b-form-input v-model="input.hargaRR" name="hargaRR" required></b-form-input>
                        </b-input-group>
                    </b-form-group>

                    <b-form-group>
                        <label>Harga Barang Baru</label>
                        <b-input-group class="mb-3" prepend="Rp.">
                            <b-form-input v-model="input.hargaBarangBaru" name="hargaBarangBaru" required></b-form-input>
                        </b-input-group>
                    </b-form-group>

                </div>
                <div class="form-content-wrapper">
                    <h6 class="form-title">STATUS BARANG</h6>
                    <b-form-group>
                        <b-form-select v-model="input.statusBarang" name="statusBarang" required>
                            <template v-slot:first>
                                <b-form-select-option :value="true">AKTIF</b-form-select-option>
                                <b-form-select-option :value="false">NON-AKTIF</b-form-select-option>
                            </template>
                        </b-form-select>
                    </b-form-group>
                </div>

                <!-- <div class="form-content-wrapper">
                    <h6 class="form-title">Surat Edaran Tipe Barang</h6>
                    <b-row>
                        <b-col cols="10" sm="3">
                            <FormulateForm v-model="pdf">
                                <FormulateInput
                                type="file"
                                name="file"
                                help="Format Harus PDF"
                                validation="mime:application/pdf"
                                accept=".pdf"
                                fileRemove
                                multiple
                                />
                            </FormulateForm>
                        </b-col>
                        <b-col cols="2">
                            <div v-for="file of input.filePDF">
                                <b-button v-if="file != null" size="sm" class="mb-3" variant="pgiBtn" @click="openModalPreviewPDF(file)">View</b-button>
                            </div>
                        </b-col>
                    </b-row> 
                </div> -->


                <!-- <div class="form-content-wrapper">
                    <h6 class="form-title">TAHUN / GENERASI</h6>
                    <label>Surat Edaran Tahun / Generasi</label>
                    <b-row>
                        <b-col cols="10" sm="3">
                            <FormulateForm v-model="pdf1">
                                <FormulateInput
                                type="file"
                                name="file"
                                help="Format Harus PDF"
                                validation="mime:application/pdf"
                                accept=".pdf"
                                fileRemove
                                multiple
                                />
                            </FormulateForm>
                        </b-col>
                        <b-col cols="2">
                            <div v-for="file of input.filePDFTahun">
                                <b-button v-if="file != null" size="sm" class="mb-3" variant="pgiBtn" @click="openModalPreviewPDF(file)">View</b-button>
                            </div>
                        </b-col>
                    </b-row> 
                    <b-form-group>
                        <b-form-checkbox
                            v-model="hargaSesuaiTahun" name="hargaSesuaiTahun"
                            :disabled="disabled"
                            >
                            Harga Berdasarkan Tahun / Generasi
                        </b-form-checkbox>
                    </b-form-group>
                    <b-form-group label="Harga" v-if="!hargaSesuaiTahun">
                        <b-input-group prepend="Rp.">
                            <b-form-input v-model="input.hargaTipeBarang" name="hargaTipeBarang" required></b-form-input>
                        </b-input-group>
                    </b-form-group>
                    <div v-else>
                        <b-button variant="pgiBtn" class="mb-2" name="hargaTahunAddBtn" @click="addHargaTahun"><i class="fa fa-plus mr-2"></i>Harga /Tahun</b-button>
                        <HargaTahun v-for="item in input.hargaTahun" v-bind:key="item.index"
                            :hargaTahun="item" :length="input.hargaTahun.length" :isKendaraan="isKendaraan" @remove="removeHargaTahun"
                            :idHargaTahun="item.id" 
                        />
                    </div>
                </div> -->

              
                <!-- <div class="form-content-wrapper">
                    <h6 class="form-title">Foto Pendukung</h6>
                    <div>
                        <b-button variant="pgiBtn" class="mb-2" @click="addFotoPendukung" name="fotoPendukungAddBtn"><i class="fa fa-plus mr-2"></i>Foto Pendukung</b-button>
                        <div class="text-danger mt-2 mb-2" v-show="fotoPendukungError">* Foto Pendukung Maksimal 6 Foto</div>
                    
                        <FotoPendukung 
                            v-for="item in input.fotoPendukung" 
                            v-bind:key="item.index" 
                            :fotoPendukung="item" 
                            :presignedUrl="presignedUrl"
                            :length="input.fotoPendukung.length" 
                            :minLength="minLengthFotoPendukung"
                            @remove="removeFotoPendukung"
                            @showModalCam="openModalCam" 
                            @showModalPreview="openModalPreview"
                        />
                    </div>
                </div> -->
                
                <!-- <div class="form-content-wrapper">
                    <h6 class="form-title">KONDISI</h6>
                    <b-form-group>
                        <b-form-checkbox
                            v-model="kondisiSesuaiMerk" name="kondisiSesuaiMerk"
                        >
                            Mengikuti Kondisi Merk
                        </b-form-checkbox>
                    </b-form-group>

                    <b-table v-if="kondisiSesuaiMerk" bordered hover responsive class="mb-3"
                        :fields="fields" 
                        :busy="isBusy" 
                        :items="kondisiBarang" 
                        show-empty>
                        <template v-slot:empty>
                            Tidak ada data kondisi dari merk yang terpilih atau merk belum dipilih
                        </template>
                        <template v-slot:cell(klasifikasi)="row">
                            <div v-if="row.item.dus !== null">
                                <span v-if="row.item.dus">Dus</span>
                                <span v-else>Non Dus</span>
                            </div>
                            <div v-else>
                                <span v-if="row.item.namaSendiri">BPKB a/n Sendiri</span>
                                <span v-else>BPKB a/n Orang Lain</span>
                            </div>
                        </template>
                        <template v-slot:cell(hargaMaksimal)="row">
                            <div class="text-right no wrap" v-if="row.item.hargaMaksimal == null">{{$helper.addThousandSeparator(row.item.hargaMaksimal)}} </div>
                            <div class="text-right no wrap text-danger" v-else-if="row.item.hargaMaksimal < 0">Rp. {{$helper.addThousandSeparator(row.item.hargaMaksimal)}} </div>
                            <div class="text-right no wrap" v-else>Rp. {{$helper.addThousandSeparator(row.item.hargaMaksimal)}} </div>
                        </template>
                        <template v-slot:cell(nominalAngka)="row">
                            <div class="text-right no wrap" v-if="row.item.nominalAngka == null">{{$helper.addThousandSeparator(row.item.nominalAngka)}} </div>
                            <div class="text-right no wrap text-danger" v-else-if="row.item.nominalAngka < 0">Rp. {{$helper.addThousandSeparator(row.item.nominalAngka)}} </div>
                            <div class="text-right no wrap" v-else>Rp. {{$helper.addThousandSeparator(row.item.nominalAngka)}} </div>
                        </template>
                        <template v-slot:cell(nominalPersen)="row">
                            <div class="text-right no-wrap" v-if="row.item.nominalPersen == null">{{$helper.addThousandSeparator(row.item.nominalPersen)}} </div>
                            <div class="text-right no-wrap text-danger" v-else-if="row.item.nominalPersen < 100 ">{{$helper.addThousandSeparator(row.item.nominalPersen)}} %</div>
                            <div class="text-right no-wrap" v-else>{{$helper.addThousandSeparator(row.item.nominalPersen)}} %</div>
                        </template>
                        <template v-slot:table-busy>
                            <div class="text-center text-danger my-2">
                                <b-spinner class="align-middle"></b-spinner>
                                <strong>  Loading data...</strong>
                            </div>
                        </template>
                    </b-table>
                    <div v-else>
                        <label>Surat Edaran Kondisi Barang</label>
                            <b-row>
                                <b-col cols="10" sm="3">
                                    <FormulateForm v-model="pdf2">
                                        <FormulateInput
                                        type="file"
                                        name="file"
                                        help="Format Harus PDF"
                                        validation="mime:application/pdf"
                                        accept=".pdf"
                                        fileRemove
                                        multiple
                                        />
                                    </FormulateForm>
                                </b-col>
                                <b-col cols="2">
                                    <div v-for="file of input.filePDFKondisi">
                                        <b-button v-if="file != null" size="sm" class="mb-3" variant="pgiBtn" @click="openModalPreviewPDF(file)">View</b-button>
                                    </div>
                                </b-col>
                            </b-row> 
                        <b-button variant="pgiBtn" class="mb-2" name="kondisiAddBtn" @click="addKondisi"><i class="fa fa-plus mr-2"></i>Kondisi</b-button>
                        <Kondisi v-for="item in input.kondisi" v-bind:key="item.index"
                            :kondisi="item" :length="input.kondisi.length" :isKendaraan="isKendaraan" @remove="removeKondisi"
                            :idKondisi="item.id" 
                            :filePDF = "item.filePDF"
                            @changeSEKon="changeSEKon"
                            @openModalPreviewPDFSpekKel = "openModalPreviewPDFTahunKondisi"
                        />
                    </div>
                </div> -->
                <div class="form-wrapper-btn submit-btn-wrapper">
                    <b-button type="submit" name="tipeBarangSubmitBtn" variant="pgiBtn">Kirim</b-button>
                </div>
            </b-form>
            <ModalPreview modalId="modal-preview-gadai" :fotoPreview="activeFotoPreview" />
        </b-card>
        <ModalConfirm id="modal-confirm-input" title="Confirm Input Tipe Barang" :isSubmitting="isSubmitting" desc="Apakah anda yakin untuk menginput tipe barang ini?" @submit="onSubmit" />
         <!-- MODAL SHOW SE -->
         <b-modal id="modal-SE" size="lg" title="Modal SE">
                <iframe width="100%" height="700" allowfullscreen :src="activePdfPreview" frameborder="0"></iframe>
                <template v-slot:modal-footer="{ cancel }">
                    <b-button variant="secondary" name="closePreviewBtn" @click="cancel()">
                        Close
                    </b-button>
                </template>
        </b-modal>
    </div>
</template>

<script>
import Vue from 'vue'
import VueFormulate from '@braid/vue-formulate'

Vue.use(VueFormulate)
import Kondisi from '../../../components/kondisi/Kondisi';
import HargaTahun from '../../../components/hargatahun/HargaTahun';
import FotoPendukung from '../../../components/webcam/FotoPendukungPresignedUrl';
import ModalPreview from '../../../components/webcam/ModalPreview';

export default {
    name: 'input-tipe-barang',
    components: {
        Kondisi, HargaTahun, FotoPendukung, ModalPreview
    },
    data(){
        return{
            initStatus: 0,
            isSubmitting: false,
            isBusy: false,
            presignedUrl: "",
            input:{
                tipeBarang: "",
                merkBarang: null,
                jenisBarang: null,
                kelompok: null,
                hargaTipeBarang: null,
                statusBarang: true,
                kondisi: [
                    {
                        index: 0, 
                        id: 0, 
                        name: "", 
                        dus: 0,
                        namaSendiri: 0,
                        detailInfo: "persen",
                        nominalPersen: null,
                        nominalAngka: null,
                        hargaMaksimal: 0
                    }
                ],
                hargaTahun: [],
                fotoPendukung: [],
                filePDF: [],
                filePDFTahun: [],
                filePDFKondisi: [],

                hargaResmi: 0, // 0 bila kendaraan
                hargaLN: 0, // 0 bila kendaraan
                hargaRR: 0, // 0 bila kendaraan
                hargaBarangBaru: 0,

                berat: null,
            },
            indexFotoPendukung: 1,
            fotoPendukungError: false,
            activeFotoPendukungIndex: null,
            activeFotoPreviewIndex: null,
            minLengthFotoPendukung: 0,
            activeFotoPreview: "",
            fields: [
                { key: "name", label: "Grade Barang", sortable:true},
                { key: "klasifikasi", label: "Klasifikasi", sortable:true},
                { key: "hargaMaksimal", label: "Harga Maksimal", sortable: true},
                { key: "nominalAngka", label: "Nominal Angka", sortable: true},
                { key: "nominalPersen", label: "Nominal Persen", sortable: true},
                { key: "keterangan", label: "Keterangan", sortable: true},
            ],
            kondisiBarang: [],
            hargaSesuaiTahun: false,
            kondisiSesuaiMerk: true,
            jenisBarang: [],
            merkBarang: [],
            indexKondisi: 1,
            indexHargaTahun: 0,
            isKendaraan: false,
            disabled: false,

            panduanNamaTipe:null,

            optKelompok: [],

            pdf: null,
            pdf1: null,
            pdf2: null,
            activePdfPreview: null
        }
    },
    methods:{
        
        //----------------- Fungsi Inisialisasi -----------------

        init(){
            this.initStatus = 0

            let getJenisBarang = this.$axios.get("barang-jenis/").then(response => {
                this.jenisBarang = response.data
            })

            let getKelompokBarang = this.$axios.get("barang-kelompok/selection").then(res => {
                this.optKelompok = res.data
                this.optKelompok.unshift({ id: 0, name: "Tidak ada kelompok" })
                this.input.kelompok = { id: 0, name: "Tidak ada kelompok" }
            })

            Promise.all([getJenisBarang, getKelompokBarang]).then(() => {
                this.initStatus = 1
            })
            .catch(() => {
                this.initStatus = -1
            })
        },


        //----------------- Fungsi Tambah Hapus Data Harga/Tahun & Kondisi -----------------

        addHargaTahun() {
            this.input.hargaTahun.unshift({
                index: this.indexHargaTahun, 
                id: 0, 
                selectedTahun: null,
                tahun: null,
                harga: null,
                filePDF: []
            })
            this.indexHargaTahun++;
        },

        removeHargaTahun(index) {
            this.input.hargaTahun = this.input.hargaTahun.filter(item => item.index != index)
        },

        addKondisi() {
            this.input.kondisi.unshift({ 
                index: this.indexKondisi, 
                id: 0, 
                name: "", 
                dus: 0,
                namaSendiri: 0,
                detailInfo: "persen",
                nominalPersen: null,
                nominalAngka: null,
                hargaMaksimal: 0
            })
            this.indexKondisi++;
        },

        removeKondisi(index) {
            this.input.kondisi = this.input.kondisi.filter(item => item.index != index)
        },

        openModalCam(index){
            this.activeFotoPendukungIndex = index
            this.$bvModal.show("webcam-input-elek")
        },

        openModalPreview(index){
            this.activeFotoPreviewIndex = index
            let idx = this.input.fotoPendukung.findIndex(item => item.index == this.activeFotoPreviewIndex);
            this.activeFotoPreview = this.input.fotoPendukung[idx].fotoBarangPendukungBase64
            this.$bvModal.show("modal-preview-gadai")
        },

        async setResult(result){
            //letakin ke null masing2
            var newResult = await this.$helper.resizeImage(result)
            let idx = this.input.fotoPendukung.findIndex(item => item.index == this.activeFotoPendukungIndex);
            this.input.fotoPendukung[idx].fotoBarangPendukungBase64 = newResult
            this.input.fotoPendukung[idx].activeFotoPendukungBase64 = newResult
            this.input.fotoPendukung[idx].fotoBarangPendukungPlaceholder = "Foto dari Kamera"
            this.input.fotoPendukung[idx].checkFotoBarangPendukung = true
        },

        //----------------- Fungsi Tambah Hapus Data Foto Pendukung -----------------

        addFotoPendukung() {
            this.getPresignedUrl()
            if(this.input.fotoPendukung.length < 6){
                this.input.fotoPendukung.unshift({ 
                    id: 0, 
                    index: this.indexFotoPendukung,
                    checkFotoBarangPendukung: false,
                    fotoBarangPendukungPlaceholder: 'Choose a file',
                    fotoBarangPendukung: null,
                    fotoBarangPendukungBase64: null,
                    activeFotoPendukungBase64: null
                })
                this.indexFotoPendukung++;
            }else{
                this.fotoPendukungError = true;
            }
        },

        removeFotoPendukung(index) {
            this.input.fotoPendukung = this.input.fotoPendukung.filter(item => item.index != index)
            this.fotoPendukungError = false;
        },

        


        //----------------- Fungsi Submit Data -----------------
        
        onSubmit(){
            let payload = new FormData()

            if (this.input.jenisBarang == 251 && this.input.berat != null && this.input.berat != '') {
                payload.append("berat",this.input.berat)
            }

            //----------------- Append Data Tipe Barang -----------------
        
              //File PDF

            // if( this.input.filePDF != null){
            //     for(var file of this.input.filePDF ){
            //         if(file.size != null){
            //             payload.append("pdfFiles" , file)
            //         }
            //         else if (file.file.size != null){
            //             payload.append("pdfFiles" , file.file)
            //         }
            //     }
            // }


              //File PDF TAHUN

            //   if( this.input.filePDFTahun != null){
            //     for(var file of this.input.filePDFTahun ){
            //         if(file.size != null){
            //             payload.append("pdfTahun" , file)
            //         }
            //         else if (file.file.size != null){
            //             payload.append("pdfTahun" , file.file)
            //         }
            //     }
            // }


              //File PDF KONDISI

            //   if( this.input.filePDFKondisi != null){
            //     for(var file of this.input.filePDFKondisi ){
            //         if(file.size != null){
            //             payload.append("pdfKondisi" , file)
            //         }
            //         else if (file.file.size != null){
            //             payload.append("pdfKondisi" , file.file)
            //         }
            //     }
            // }


            // if (this.hargaSesuaiTahun == true) {
            //     if (this.isKendaraan == true) {
            //         for (var x of this.input.hargaTahun) {
            //             let hargaKendaraan = this.$helper.removeThousandSeparator(x.hargaKendaraan);
            //             let hargaBpkb = this.$helper.removeThousandSeparator(x.hargaBpkb);
            //             payload.append('tahunId', 0) 
            //             payload.append('tahunTahun', x.selectedTahun)
            //             payload.append('tahunHarga', null)
            //             payload.append('tahunHargaKendaraan', hargaKendaraan)
            //             payload.append('tahunHargaBpkb', hargaBpkb)
            //         }
            //     } 
            //     else {
            //         for (var x of this.input.hargaTahun) {
            //             let harga = this.$helper.removeThousandSeparator(x.harga);
            //             payload.append('tahunId', 0)
            //             payload.append('tahunTahun', x.selectedTahun)
            //             payload.append('tahunHarga', harga)
            //             payload.append('tahunHargaKendaraan', null)
            //             payload.append('tahunHargaBpkb', null)
            //         }
            //     }
            // } 
            // else {
            //     let hargaTipeBarang = this.$helper.removeThousandSeparator(this.input.hargaTipeBarang);
            //     payload.append('harga', hargaTipeBarang)
            // }
            
            // if (this.kondisiSesuaiMerk == true) payload.append('useKondisiMerk', true) 
            // else {
            //     payload.append('useKondisiMerk', false)
            //     for (var x of this.input.kondisi) {
            //         payload.append('kondisiId', 0)
            //         payload.append('kondisiName', x.name)
            //         const nominalHargaMaks = this.$helper.removeThousandSeparator(x.hargaMaksimal);
            //         payload.append('kondisiHargaMaksimal', nominalHargaMaks)
            //         if (this.isKendaraan == false) {
            //             if (x.dus == 0) {
            //                 status = true
            //             } 
            //             else {
            //                 status = false
            //             }
            //             payload.append('kondisiDus', status)
            //         } else {
            //             if (x.namaSendiri== 0) {
            //                 status = true
            //             } 
            //             else {
            //                 status = false
            //             }
            //             payload.append('kondisiNamaSendiri', status)
            //         }
            //         if (x.detailInfo == 'nominal') {
            //             let nominalAngka = this.$helper.removeThousandSeparator(x.nominalAngka);
            //             payload.append('kondisiNominalAngka', nominalAngka) // todo
            //             payload.append('kondisiNominalPersen', null)
            //         } 
            //         else {
            //             payload.append('kondisiNominalPersen', x.nominalPersen)
            //             payload.append('kondisiNominalAngka', null)
            //         }
            //     }
            // }

            // Check if there is at least one picture attached
            // if(this.input.fotoPendukung.length == 1 && this.$helper.isNullOrEmpty(this.input.fotoPendukung[0].activeFotoPendukungBase64)) {
            //     this.$helper.toastErr(this, "Mohon upload minimal 1 gambar!")
            //     return
            // }

            // Check if all photo row has been filled
            // for(var i = 0; i < this.input.fotoPendukung.length; i++) {
            //     let item = this.input.fotoPendukung[i]
            //     if(this.$helper.isNullOrEmpty(item.activeFotoPendukungBase64)) {
            //         this.$helper.toastErr(this, "Terdapat upload gambar yang kosong, periksa kembali!")
            //         return
            //     }
            // }

            // let jsonFoto = []
            //     this.input.fotoPendukung.forEach(function(entry) {
            //         jsonFoto.push(entry.activeFotoPendukungBase64)  
            //     })

            // payload.append("fotoBarang", JSON.stringify(jsonFoto))
            // payload.append("name", this.input.tipeBarang)
            // payload.append("merkBarangId", this.input.merkBarang)
            // payload.append("hasTahun", this.hargaSesuaiTahun)
            // payload.append("isActive", this.input.statusBarang)
            
            
            // if(this.input.kelompok == null){
            //     this.$helper.toastErr(this, "Mohon Input Kelompok Barang")
            //     return
            // }

            // Kelompok
            // if(this.input.kelompok.id != 0) { // 0 artinya tidak ada kelompok
            //     payload.append("kelompokId", this.input.kelompok.id)
            // }

            let json = {
                        name: this.input.tipeBarang,
                        merkId: this.input.merkBarang,
                        isActive: this.input.statusBarang,
                        hargaResmi: this.$helper.removeThousandSeparator(this.input.hargaResmi), // 0 bila kendaraan
                        hargaLN: this.$helper.removeThousandSeparator(this.input.hargaLN), // 0 bila kendaraan
                        hargaRR: this.$helper.removeThousandSeparator(this.input.hargaRR), // 0 bila kendaraan
                        hargaBarangBaru: this.$helper.removeThousandSeparator(this.input.hargaBarangBaru),
                        kelompokId: (this.input.kelompok.id != 0) ? this.input.kelompok.id :null,
                        berat: this.input.berat,
                        // fileTempUrl : arrayUrl
                    }
            
            //----------------- Submit Semua Data -----------------

            this.isSubmitting = true
            this.$axios.post("barang-tipe-v2/insert", json).then(response => {
                this.$helper.setFlash(`Tipe barang baru telah berhasil dibuat!`)
                let path = this.$route.path.split('/')
                path.pop()
                path = path.join("/") + `/${response.data.id}`
                this.$router.push({ path })
            })
            .catch(error => {
                this.$helper.parseError(this, error)
            })
            .finally(() => {
                this.isSubmitting = false
            })
        },


        //----------------- Fungsi Lain -----------------

        openModalConfirm(){

            // if(this.input.filePDF != null){
            // for(var file of this.input.filePDF){
                   
            //         if(file.type != null){
            //                 if(file.type != "application/pdf" ){
            //                 this.$helper.toastErr(this, 'file '+file.name+' bukan PDF')
            //                 return
            //             }
            //         }else{
            //                 if(file.file.type != "application/pdf"){
            //                 this.$helper.toastErr(this, 'file '+file.name+' bukan PDF')
            //                 return
            //             }
            //         } 
            //     }
            // }

            // if(this.input.filePDFTahun != null){
            // for(var file of this.input.filePDFTahun){
        
            //         if(file.type != null){
            //                 if(file.type != "application/pdf" ){
            //                 this.$helper.toastErr(this, 'file '+file.name+' bukan PDF')
            //                 return
            //             }
            //         }else{
            //                 if(file.file.type != "application/pdf"){
            //                 this.$helper.toastErr(this, 'file '+file.name+' bukan PDF')
            //                 return
            //             }
            //         } 
            //     }
            // }

            // if(this.input.filePDFKondisi != null){
            // for(var file of this.input.filePDFKondisi){
                
            //         if(file.type != null){
            //                 if(file.type != "application/pdf" ){
            //                 this.$helper.toastErr(this, 'file '+file.name+' bukan PDF')
            //                 return
            //             }
            //         }else{
            //                 if(file.file.type != "application/pdf"){
            //                 this.$helper.toastErr(this, 'file '+file.name+' bukan PDF')
            //                 return
            //             }
            //         } 
            //     }
            // }

            // if (this.hargaSesuaiTahun == true && this.input.hargaTahun.length == 0) {
            //     this.$helper.toastErr(this, "Tolong masukkan minimal data 1 tahun")
            // } 
            // else if (this.kondisiSesuaiMerk == false && this.input.kondisi.length == 0) {
            //     this.$helper.toastErr(this, "Tolong masukkan minimal 1 kondisi")
            // } 
            // else {
            //     this.$bvModal.show("modal-confirm-input")
            // }
            if (this.$helper.isNullOrEmpty(this.input.jenisBarang)) {
                return this.$helper.toastErr(this, "Mohon isi Jenis Barang!")
            }
            if (this.$helper.isNullOrEmpty(this.input.merkBarang)) {
                return this.$helper.toastErr(this, "Mohon isi Merk Barang!")
            }
            if (this.$helper.isNullOrEmpty(this.input.tipeBarang)) {
                return this.$helper.toastErr(this, "Mohon isi Nama Tipe!")
            }
            if (this.input.jenisBarang != null && this.input.jenisBarang == 13 || this.input.jenisBarang == 14) {
                this.input.hargaResmi = 0
                this.input.hargaLN = 0
                this.input.hargaRR = 0
            }

            if (this.$helper.isNullOrEmpty(this.input.hargaResmi)) {
                this.input.hargaResmi = 0
            }
            if (this.$helper.isNullOrEmpty(this.input.hargaLN)) {
                this.input.hargaLN = 0
            }
            if (this.$helper.isNullOrEmpty(this.input.hargaRR)) {
                this.input.hargaRR = 0
            }
            if (this.$helper.isNullOrEmpty(this.input.hargaBarangBaru)) {
                this.input.hargaBarangBaru = 0
            }

            this.$bvModal.show("modal-confirm-input")
        },

        toggleBusy() {
            if (this.isBusy == true) this.isBusy = false
            else this.isBusy = true
        },

        toBase64(file) {
            return new Promise((resolve, reject) => {
                const reader = new FileReader()
                reader.readAsDataURL(file)
                reader.onload = () => resolve(reader.result)
                reader.onerror = error => reject(error)
            })

        },

        openModalPreviewPDF(pdf){
                 this.toBase64(pdf).then(async base64 => {   
                    this.activePdfPreview = base64
                })
            this.$bvModal.show("modal-SE")
        },


          //----------------- Fungsi SE Spesifikasi -----------------
          changeSEHargaTahun(idTahun,filePDF){
            let idx = this.input.hargaTahun.findIndex(item => item.id == idTahun)
            this.input.hargaTahun[idx].filePDF = filePDF
        },

        openModalPreviewPDFTahunKondisi(base64){
            this.activePdfPreview = base64
            this.$bvModal.show("modal-SE")
        },

        changeSEKon(idKondisi,filePDF){
            let idx = this.input.kondisi.findIndex(item => item.id == idKondisi)
            this.input.kondisi[idx].filePDF = filePDF
        },

        roundPersen(){
            var desimalBerat = Number(this.input.berat).toFixed(2);
			this.input.berat = desimalBerat;
		},
        getPresignedUrl() {
            this.$axios.get(`/s3/url-temp?contentType=image`).then(response => {
                this.presignedUrl = response.data.name
                
                // this.uploadViaPresignedUrl(this.input)
            }).catch(error => {
                this.$helper.parseError(this, error)
            })
        },


        resetInput(){
            this.input = {
                tipeBarang: "",
                merkBarang: null,
                jenisBarang: null,
                kelompok: null,
                hargaTipeBarang: null,
                statusBarang: true,
                kondisi: [
                    {
                        index: 0, 
                        id: 0, 
                        name: "", 
                        dus: 0,
                        namaSendiri: 0,
                        detailInfo: "persen",
                        nominalPersen: null,
                        nominalAngka: null,
                        hargaMaksimal: 0
                    }
                ],
                hargaTahun: [],
                fotoPendukung: [],
                filePDF: [],
                filePDFTahun: [],
                filePDFKondisi: [],

                hargaResmi: 0, // 0 bila kendaraan
                hargaLN: 0, // 0 bila kendaraan
                hargaRR: 0, // 0 bila kendaraan
                hargaBarangBaru: 0,

                berat: null,
            }
        }
    },

    watch:{

        "input.hargaTipeBarang": function(newValue) {
            if (newValue.length > 1 && newValue.charAt(0) == 0) {
                newValue = parseFloat(newValue).toString()
            }
            const result = newValue.replace(/\D/g, "")
                .replace(/\B(?=(\d{3})+(?!\d))/g, ".");
            this.$nextTick(() => this.input.hargaTipeBarang = result);
        },
        "input.hargaResmi": function(newValue) {
            if (newValue.length > 1 && newValue.charAt(0) == 0) {
                newValue = parseFloat(newValue).toString()
            }
            const result = newValue.replace(/\D/g, "")
                .replace(/\B(?=(\d{3})+(?!\d))/g, ".");
            this.$nextTick(() => this.input.hargaResmi = result);
        },
        "input.hargaLN": function(newValue) {
            if (newValue.length > 1 && newValue.charAt(0) == 0) {
                newValue = parseFloat(newValue).toString()
            }
            const result = newValue.replace(/\D/g, "")
                .replace(/\B(?=(\d{3})+(?!\d))/g, ".");
            this.$nextTick(() => this.input.hargaLN = result);
        },
        "input.hargaRR": function(newValue) {
            if (newValue.length > 1 && newValue.charAt(0) == 0) {
                newValue = parseFloat(newValue).toString()
            }
            const result = newValue.replace(/\D/g, "")
                .replace(/\B(?=(\d{3})+(?!\d))/g, ".");
            this.$nextTick(() => this.input.hargaRR = result);
        },
        "input.hargaBarangBaru": function(newValue) {
            if (newValue.length > 1 && newValue.charAt(0) == 0) {
                newValue = parseFloat(newValue).toString()
            }
            const result = newValue.replace(/\D/g, "")
                .replace(/\B(?=(\d{3})+(?!\d))/g, ".");
            this.$nextTick(() => this.input.hargaBarangBaru = result);
        },


        //----------------- Pantau Jenis Barang -----------------

        'input.jenisBarang': function(id){
            this.merkBarang = []
            this.kondisiBarang = []
            this.$axios.get(`barang-merk/jenis/${id}`).then(response => {
                this.input.merkBarang = null
                this.merkBarang = response.data
                if (this.isBusy == true) this.toggleBusy()
            })
            .catch(error => {
                this.$helper.parseError(this, error)
                if (this.isBusy == true) this.toggleBusy()
            })
         
            this.$axios.get(`barang-jenis/panduan-nama-tipe/${id}`).then(response => {
                this.panduanNamaTipe = response.data
                if (this.isBusy == true) this.toggleBusy()
            })
            .catch(error => {
                this.$helper.parseError(this, error)
                if (this.isBusy == true) this.toggleBusy()
            })

            let jenis = this.jenisBarang.filter(item => item.id == id)
            let namaJenis = jenis[0].jenisPinjaman.name
            if (namaJenis == 'Kendaraan') {
                this.isKendaraan = true
                this.hargaSesuaiTahun = true
                this.disabled = true
            } 
            else if (namaJenis == 'Elektronik') {
                this.isKendaraan = false
                this.disabled = false
            }
        },


        //----------------- Pantau Merk Barang -----------------

        'input.merkBarang': function(id){
            this.toggleBusy()
            if (this.input.merkBarang != null) {
                this.$axios.get(`barang-merk/kondisi/${id}`).then(response => {
                    this.kondisiBarang = response.data
                    if (this.isBusy == true) this.toggleBusy()
                })
                .catch(error => {
                    this.$helper.parseError(this, error)
                    if (this.isBusy == true) this.toggleBusy()
                })
            }
            if (this.isBusy == true) this.toggleBusy()
        },

        //PDF TIPE
        "pdf.file.files": function (newValue) {   
            let Pdfbase64 = []
            if(newValue.length != 0){
                for(var file of newValue){
                Pdfbase64.push(file.file)
                }
            this.input.filePDF = Pdfbase64
            }
            if(newValue.length == 0){
                this.input.filePDF = null
            }
        },

        //PDF TAHUN
        "pdf1.file.files": function (newValue) {   
            let Pdfbase64 = []
            if(newValue.length != 0){
                for(var file of newValue){
                Pdfbase64.push(file.file)
                }
            this.input.filePDFTahun = Pdfbase64
            }
            if(newValue.length == 0){
                this.input.filePDFTahun = null
            }
        },

          //PDF KONDISI
          "pdf2.file.files": function (newValue) {   
            let Pdfbase64 = []
            if(newValue.length != 0){
                for(var file of newValue){
                Pdfbase64.push(file.file)
                }
            this.input.filePDFKondisi = Pdfbase64
            }
            if(newValue.length == 0){
                this.input.filePDFKondisi = null
            }
        },

    },
    
    created(){
        this.init()
        this.getPresignedUrl()
    }
}
</script>
